import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Layout } from 'antd';
import Sidebar from './Sidebar';
import Header from './Header';
import { cn } from '../../utils/tailwindUtils';

const { Content } = Layout;

const AppLayout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <Layout className="min-h-screen">
      {/* Sidebar */}
      <Sidebar
        collapsed={collapsed}
        onCollapse={setCollapsed}
        mobileOpen={mobileOpen}
        onMobileClose={() => setMobileOpen(false)}
      />

      {/* Main area — shifts right to account for fixed sidebar */}
      <Layout
        className={cn(
          'transition-all duration-300',
          'md:ml-[240px]',
          collapsed && 'md:ml-[72px]'
        )}
        style={{ minHeight: '100vh' }}
      >
        <Header onMenuClick={() => setMobileOpen(true)} />

        <Content className="p-4 sm:p-6 bg-background overflow-y-auto">
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default AppLayout;
